module.exports = __webpack_public_path__ + "img/jichu.192451d1.jpg";